<template>
  <div id="user-profile-page" v-resize="onResize">
    <div class="box-1">
      <div
        :style="{
          display: windowSize <= 600 ? '' : 'flex',
          width: windowSize <= 600 ? '100%' : '65%'
        }"
        class="left"
      >
        <div
          :style="{
            width: '100%',
            'font-family': 'Bai Jamjuree, sans-serif'
          }"
        >
          <div style="display: flex;">
            <div :style="{ width: '100%', padding: windowSize <= 600 ? '12px 15px 12px 15px' : '32px 15px 12px 15px',  }">
              <div class="btn-filter" @click="tab = 'profile'">Profile</div>
            </div>
            <!-- <div :style="{ width: '100%', padding: windowSize <= 600 ? '12px 15px 12px 15px' : '32px 15px 12px 15px', cursor: 'pointer' }">
              <div class="btn-filter" @click="onClickShipmentTab">Shipment</div>
            </div> -->
          </div>
          <div>
            <!-- Profile Tab -->
            <div v-if="tab === 'profile'" class="profile">
              <div >
            <div v-if="tab === 'profile'"
            :style="{ width: '100%', display: windowSize <= 600 ? '' : 'flex' }">
            <div :style="{ width: windowSize <= 600 ? '100%' : '50%' }">
              <div :style="{ width: '100%', padding: '12px 15px 12px 15px' }">
                <div class="md-layout">
                  <div class="head-40">รหัสผู้ใช้งาน</div>
                  <div class="detail-40" style="">
                    {{ this.profile.user_id }}
                  </div>
                </div>
              </div>
              <div :style="{ width: '100%', padding: '12px 15px 12px 15px' }">
                <div class="md-layout">
                  <div class="head-40">
                    อีเมล <span style="color:red">*</span>
                  </div>
                  <div class="detail-40">
                    <input
                      v-bind:class="[Error.errorClassEmail]"
                      :style="{
                        'background-color':
                          isDisabled || input_cheang_password
                            ? '#DADADA'
                            : '#fff'
                      }"
                      :disabled="isDisabled || input_cheang_password"
                      v-model="profile.user_email"
                      class="input-style"
                    />
                    <div
                      v-if="this.Error.errorClassEmail != ''"
                      class="txt-wrong"
                    >
                      <span class="mdi mdi-alert-octagon"></span>
                      {{ this.Error.errorClassEmail_txt }}
                    </div>
                  </div>
                </div>
              </div>
              <div :style="{ width: '100%', padding: '12px 15px 12px 15px' }">
                <div class="md-layout">
                  <div class="head-40">
                    ชื่อ <span style="color:red">*</span>
                  </div>
                  <div class="detail-40">
                    <input
                      v-bind:class="[Error.errorClassFirstName]"
                      :style="{
                        'background-color':
                          isDisabled || input_cheang_password
                            ? '#DADADA'
                            : '#fff'
                      }"
                      :disabled="isDisabled || input_cheang_password"
                      v-model="profile.user_name"
                      class="input-style"
                    />
                    <div
                      v-if="this.Error.errorClassFirstName != ''"
                      class="txt-wrong"
                    >
                      <span class="mdi mdi-alert-octagon"></span>
                      {{ this.Error.errorClassFirstName_txt }}
                    </div>
                  </div>
                </div>
              </div>
              <div :style="{ width: '100%', padding: '12px 15px 12px 15px' }">
                <div class="md-layout">
                  <div class="head-40">
                    นามสกุล <span style="color:red">*</span>
                  </div>
                  <div class="detail-40">
                    <input
                      v-bind:class="[Error.errorClassLastName]"
                      :style="{
                        'background-color':
                          isDisabled || input_cheang_password
                            ? '#DADADA'
                            : '#fff'
                      }"
                      :disabled="isDisabled || input_cheang_password"
                      v-model="profile.user_surname"
                      class="input-style"
                    />
                    <div
                      v-if="this.Error.errorClassLastName != ''"
                      class="txt-wrong"
                    >
                      <span class="mdi mdi-alert-octagon"></span>
                      {{ this.Error.errorClassLastName_txt }}
                    </div>
                  </div>
                </div>
              </div>
              <div :style="{ width: '100%', padding: '12px 15px 12px 15px' }">
                <div class="md-layout">
                  <div class="head-40">
                    ชื่อบริษัท <span style="color:red">*</span>
                  </div>
                  <div class="detail-40">
                    <input
                      v-bind:class="[Error.errorClassCompanyName]"
                      :style="{
                        'background-color':
                          isDisabled || input_cheang_password
                            ? '#DADADA'
                            : '#fff'
                      }"
                      :disabled="isDisabled || input_cheang_password"
                      v-model="profile.user_company"
                      class="input-style"
                    />
                    <div
                      v-if="this.Error.errorClassLastName != ''"
                      class="txt-wrong"
                    >
                      <span class="mdi mdi-alert-octagon"></span>
                      {{ this.Error.errorClassLastName_txt }}
                    </div>
                  </div>
                </div>
              </div>
              <div :style="{ width: '100%', padding: '12px 15px 12px 15px' }">
                <div class="md-layout">
                  <div class="head-40">
                    เบอร์โทรศัพท์<span style="color:red">*</span>
                  </div>
                  <div class="detail-40">
                    <input
                      v-bind:class="[Error.errorClassTel]"
                      :style="{
                        'background-color':
                          isDisabled || input_cheang_password
                            ? '#DADADA'
                            : '#fff'
                      }"
                      :disabled="isDisabled || input_cheang_password"
                      v-model="profile.user_phone"
                      class="input-style"
                    />
                    <div
                      v-if="this.Error.errorClassTel != ''"
                      class="txt-wrong"
                    >
                      <span class="mdi mdi-alert-octagon"></span>
                      {{ this.Error.errorClassTel_txt }}
                    </div>
                  </div>
                </div>
              </div>
              <div :style="{ width: '100%', padding: '12px 15px 12px 15px' }">
                <div class="md-layout">
                  <div class="head-40">
                    เบอร์โทรศัพท์สำรอง<span style="color:red">*</span>
                  </div>
                  <div class="detail-40">
                    <input
                      v-bind:class="[Error.errorClassTel]"
                      :style="{
                        'background-color':
                          isDisabled || input_cheang_password
                            ? '#DADADA'
                            : '#fff'
                      }"
                      :disabled="isDisabled || input_cheang_password"
                      v-model="profile.user_phone"
                      class="input-style"
                    />
                    <div
                      v-if="this.Error.errorClassTel != ''"
                      class="txt-wrong"
                    >
                      <span class="mdi mdi-alert-octagon"></span>
                      {{ this.Error.errorClassTel_txt }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div :style="{ width: windowSize <= 600 ? '100%' : '50%' }">
              <div
                :style="{ width: '100%', padding: '12px 15px 12px 15px' }"
                v-if="windowSize > 600"
              >
                <div class="md-layout" style="visibility: hidden">test</div>
              </div>
              <div :style="{ width: '100%', padding: '12px 15px 12px 15px' }">
                <div v-if="!input_cheang_password" class="md-layout">
                  <div class="head-40">
                    รหัสผ่าน <span style="color:red">*</span>
                  </div>
                  <div class="detail-40">
                    <md-field
                      :md-toggle-password="false"
                      :style="{
                        'background-color': isDisabled ? '#DADADA' : '#fff'
                      }"
                      class="input-style"
                      style="min-height:34px ;margin:0;top:0 ; left:0"
                    >
                      <md-input
                        :disabled="true"
                        class="input-style"
                        type="password"
                        v-model="edit_val.val_pass"
                      ></md-input>
                      <!-- <div v-if="isDisabled">
                        <span
                          style="cursor: pointer;padding:0 10px 0 0;"
                          class="md-suffix mdi mdi-eye-off"
                        ></span>
                      </div> -->

                      <div v-if="!isDisabled" style="display: flex;" >
                        <span
                          @click="cheang_password"
                          style="display: flex;padding:0 10px 0 0;font-size:12px;align-items: center;cursor: pointer;"
                          >เปลี่ยน</span
                        >
                      </div>
                    </md-field>
                  </div>
                </div>

                <div v-else class="md-layout">
                  <div class="head-40">
                    รหัสผ่านปัจจุบัน <span style="color:red">*</span>
                  </div>
                  <div class="detail-40">
                    <md-field
                      v-bind:class="[Error.errorClassPwd]"
                      :md-toggle-password="false"
                      :style="{
                        'background-color': isDisabled ? '#DADADA' : '#fff'
                      }"
                      class="input-style"
                      style="min-height:34px ;margin:0;top:0 ; left:0"
                    >
                      <md-input
                        class="input-style"
                        :type="!this.icon_eye.password ? 'password' : 'text'"
                        v-model="edit_val.val_pass"
                      ></md-input>
                      <span
                        v-if="!this.icon_eye.password"
                        @click="HideShow('password')"
                        style="cursor: pointer;padding:0 10px 0 0;"
                        class="md-suffix mdi mdi-eye-off"
                      ></span>
                      <span
                        v-else
                        @click="HideShow('password')"
                        style="cursor: pointer;padding:0 10px 0 0;"
                        class="md-suffix mdi mdi-eye"
                      ></span>
                    </md-field>
                    <div
                      v-if="this.Error.errorClassPwd != ''"
                      class="txt-wrong"
                    >
                      <span class="mdi mdi-alert-octagon"></span>
                      {{ this.Error.errorClassPwd_txt }}
                    </div>
                  </div>
                </div>
              </div>
              <div :style="{ width: '100%', padding: '12px 15px 12px 15px' }">
                <div class="md-layout">
                  <div class="head-40">
                    ที่อยู่ <span style="color:red">*</span>
                  </div>
                  <div class="detail-40">
                    <input
                      v-bind:class="[Error.errorClassAddress]"
                      :style="{
                        'background-color':
                          isDisabled || input_cheang_password
                            ? '#DADADA'
                            : '#fff'
                      }"
                      :disabled="isDisabled || input_cheang_password"
                      v-model="profile.user_address"
                      class="input-style"
                    />
                    <div
                      v-if="this.Error.errorClassAddress != ''"
                      class="txt-wrong"
                    >
                      <!-- <span class="mdi mdi-alert-octagon"></span>
                      {{ this.Error.errorClassAddress_txt }} -->
                    </div>
                  </div>
                </div>
              </div>
              <div :style="{ width: '100%', padding: '12px 15px 12px 15px' }">
                <div v-if="input_cheang_password" class="md-layout">
                  <div class="head-40">
                    รหัสผ่านใหม่ <span style="color:red">*</span>
                  </div>
                  <div class="detail-40">
                    <md-field
                      v-bind:class="[Error.errorClassNewPwd]"
                      :md-toggle-password="false"
                      :style="{
                        'background-color': isDisabled ? '#DADADA' : '#fff'
                      }"
                      class="input-style"
                      style="min-height:34px ;margin:0;top:0 ; left:0"
                    >
                      <md-input
                        class="input-style"
                        :type="
                          !this.icon_eye.new_password ? 'password' : 'text'
                        "
                        v-model="edit_val.new_password"
                      ></md-input>
                      <span
                        v-if="!this.icon_eye.new_password"
                        @click="HideShow('new_password')"
                        style="cursor: pointer;padding:0 10px 0 0;"
                        class="md-suffix mdi mdi-eye-off"
                      ></span>
                      <span
                        v-else
                        @click="HideShow('new_password')"
                        style="cursor: pointer;padding:0 10px 0 0;"
                        class="md-suffix mdi mdi-eye"
                      ></span>
                    </md-field>
                    <div v-if="this.Error.errorClassNewPwd_txt != ''">
                      <div class="txt-wrong">
                        <span class="mdi mdi-alert-octagon"></span>
                        {{ this.Error.errorClassNewPwd_txt }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div :style="{ width: '100%', padding: '12px 15px 12px 15px' }">
                <div v-if="input_cheang_password" class="md-layout">
                  <div class="head-40">
                    ยืนยันรหัสผ่าน <span style="color:red">*</span>
                  </div>
                  <div class="detail-40">
                    <md-field
                      v-bind:class="[Error.errorClassConfNewPwd]"
                      :md-toggle-password="false"
                      :style="{
                        'background-color': isDisabled ? '#DADADA' : '#fff'
                      }"
                      class="input-style"
                      style="min-height:34px ;margin:0;top:0 ; left:0"
                    >
                      <md-input
                        class="input-style"
                        :type="
                          !this.icon_eye.confrim_new_password
                            ? 'password'
                            : 'text'
                        "
                        v-model="edit_val.confrim_password"
                      ></md-input>
                      <span
                        v-if="!this.icon_eye.confrim_new_password"
                        @click="HideShow('confrim_new_password')"
                        style="cursor: pointer;padding:0 10px 0 0;"
                        class="md-suffix mdi mdi-eye-off"
                      ></span>
                      <span
                        v-else
                        @click="HideShow('confrim_new_password')"
                        style="cursor: pointer;padding:0 10px 0 0;"
                        class="md-suffix mdi mdi-eye"
                      ></span>
                    </md-field>
                    <div
                      v-if="this.Error.errorClassConfNewPwd != ''"
                      class="txt-wrong"
                    >
                      <span class="mdi mdi-alert-octagon"></span>
                      {{ this.Error.errorClassConfNewPwd_txt }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            :style="{
              width: '100%',
              padding: '12px 15px 12px 15px',
              display: 'flex',
              'justify-content': 'flex-end'
            }"
          >
            <div
              v-if="!isDisabled"
              @click="cancel"
              style="cursor: pointer;padding:0 10px 0 0;display: flex;align-items: center;"
            >
              ยกเลิก
            </div>
            <v-btn v-if="isDisabled" rounded class="ok" @click="edit()">
              แก้ไข
            </v-btn>

            <v-btn v-else rounded class="ok" @click="save()">
              บันทึก
            </v-btn>
          </div>
          </div>
            </div>
          </div>
          <div>
            <!-- Shipment Tab -->
            <div v-if="tab === 'shipment'" class="shipment">
              <div style="" class="detail-table" v-resize="onResize">
                <div class="" style="padding:8px 23px 8px 0">
                  <b-row>
                    <b-col style="padding:20px 0 0px 8%" xl>
                      <div style="width:90%">
                        <div class="btn-filter-title">Shipment</div>
                      </div>
                    </b-col>
                  </b-row>
                  <div class="count-subtitle" style="width:40%">
                    <!-- พบ {{ shipmentData.length }} รายการ -->
                  </div>
                  <div style="padding:10px 20px 20px 0;width:100%;text-align:end;">
                    <v-btn rounded @click="view_add()" class="ok" style="padding:20px 10px 20px 10px;width:unset">
                      + Add Shipment
                    </v-btn>
                  </div>
                </div>
                <div v-if="shipmentData.length != 0" class="table d-flex flex-wrap justify-center">
                  <div
                    :class="checkbox ? 'card selected' : 'card'"
                    v-for="(row, index) in shipmentData"
                    :key="'card-' + index + '-' + row.id"
                    style="min-width:320px; max-width:400px; margin:12px; border-radius:14px; box-shadow:0 2px 8px #e0e0e0; border:1px solid #e0e0e0;"
                  >
                    <div class="row-card" style="padding: 16px 18px 8px 18px; font-size: 18px; font-weight: bold; display: flex; align-items: center;">
                      <span>{{ row.acc_name }}</span>
                      <span style="margin: 0 8px;">|</span>
                      <span>{{ row.acc_phone }}</span>
                    </div>
                    <div class="row-card" style="padding: 0 18px 12px 18px; color: #555; font-size: 15px;">
                      {{ row.acc_address }},
                      {{ row.acc_sub_district }},
                      {{ row.acc_district }},
                      {{ row.acc_province }},
                      {{ row.acc_zip_code }}
                    </div>
                    <div style="display: flex; justify-content: flex-end; margin: 10px;">
                      <div
                        variant="text"
                        small
                        @click="editShipment(row, index)"
                        style="color: #1976d2; text-transform: none; margin-right: 8px; cursor: pointer;"
                      >
                        แก้ไข
                      </div>
                      <div
                        variant="text"
                        small
                        @click="deleteShipment(row, index)"
                        style="color: #1976d2; text-transform: none; cursor: pointer;"
                      >
                        ลบ
                      </div>
                    </div>
                    
                  </div>
                </div>
                <div
                  style="padding-top:8%;font-size: 40px;color: rgba(0, 0, 0, 0.6);"
                  class="table d-flex flex-wrap justify-center"
                  v-else
                >
                  ไม่พบข้อมูลที่ค้นหา กรุณากรอกข้อมูลใหม่
                </div>
              </div>
            </div>
          </div>
        </div>
      
        <v-dialog v-model="dialog" persistent max-width="454px">
          <v-card style="border-radius: 40px;padding: 0;">
            <v-card-text style="border-radius:40px;padding: 0;">
              <v-container
                style="display: flex;
               border-radius: 40px 40px 0 0;
                background-color: rgb(236, 241, 255);
                justify-content: center;
                font-family: 'Bai Jamjuree', sans-serif 
                "
              >
                <div class="my-layout">
                  <div><img class="img" src="@/assets/images/lock.png" /></div>
                  <div>คุณต้องการ<b>เปลี่ยนรหัสผ่าน</b>ใช่หรือไม่</div>
                </div>
              </v-container>
            </v-card-text>
            <v-card-actions
              style="font-family: 'Bai Jamjuree', sans-serif ; display: flex;
              justify-content: center;"
            >
              <button
                @click="confrim_dialog('OK')"
                style="width: 84px;
                    height: 35px;
                    background: #000000;
                    border-radius: 8px;
                    color:#fff;
                    "
              >
                ใช่
              </button>
              <button
                @click="confrim_dialog('cancel')"
                style="
                    margin:0 0 0 20px;
                    width: 84px;
                    height: 35px;
                    background: #fff;
                    border-radius: 8px;
                    color:#000;
                    border:2px solid #000;
                    "
              >
                ไม่
              </button>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_success" persistent max-width="454px">
          <v-card style="border-radius: 40px;padding: 0;">
            <v-card-text style="border-radius:40px;padding: 0;">
              <v-container
                style="display: flex;
               border-radius: 40px 40px 0 0;
                background-color: rgb(236, 241, 255);
                justify-content: center;
                font-family: 'Bai Jamjuree', sans-serif 
                "
              >
                <div class="my-layout">
                  <div>
                    <img
                      :style="{ height: '200px', width: '200px' }"
                      class="img"
                      src="@/assets/images/success.png"
                    />
                  </div>
                  <div
                    style="color: #000000;font-size: 16px;display: flex;justify-content: center;"
                  >
                    บันทึกสำเร็จ
                  </div>
                </div>
              </v-container>
            </v-card-text>
            <v-card-actions
              style="font-family: 'Bai Jamjuree', sans-serif ; display: flex;
              justify-content: center;"
            >
              <button
                @click="success_()"
                style="width: 84px;
                    height: 35px;
                    background: #000000;
                    border-radius: 8px;
                    color:#fff;
                    "
              >
                ตกลง
              </button>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogAddShipment" persistent max-width="600px">
          <v-card style="border-radius:14px">
            <div v-resize="onResize" id="detail-dialog-admin">
              <div class="d-dialog" :style="{padding: windowSize < 600 ? '0px 5px 10px 0px' : '25px 25px 15px 25px'}">
                <div style="width:100%;display:flex">
                  <div :style="{padding: windowSize < 600 ? '20px 10px 0px 10px' : '0px 0px 0px 5px', width: '70%'}">
                    <div class="btn-filter-head">Add Shipment</div>
                  </div>
                </div>
                <div class="box-detail">
                  <b-container style="font-family:'Bai Jamjuree', sans-serif" class="accentbv-example-row">
                    <b-row>
                      <b-col xl>
                        <div class="md-layout">
                          <div class="head">ผู้ส่ง <span style="color:red">*</span></div>
                          <div class="detail">
                            <md-field>
                              <md-input
                                v-model="newShipment.acc_name"
                                class="input-style2"
                              ></md-input>
                            </md-field>
                          </div>
                        </div>
                      </b-col>
                      <b-col xl>
                        <div class="md-layout">
                          <div class="head">เบอร์โทรผู้ส่ง <span style="color:red">*</span></div>
                          <div class="detail">
                            <md-field>
                              <md-input
                                v-model="newShipment.acc_phone"
                                class="input-style2"
                              ></md-input>
                            </md-field>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col xl>
                        <div class="md-layout">
                          <div class="head">ที่อยู่ผู้ส่ง <span style="color:red">*</span></div>
                          <div class="detail">
                            <md-field>
                              <md-input
                                v-model="newShipment.acc_address"
                                class="input-style2"
                              ></md-input>
                            </md-field>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col xl>
                        <div class="md-layout">
                          <div class="head">จังหวัด <span style="color:red">*</span></div>
                          <div class="detail">
                            <md-field>
                              <md-input
                                v-model="newShipment.acc_province"
                                class="input-style2"
                              ></md-input>
                            </md-field>
                          </div>
                        </div>
                      </b-col>
                      <b-col xl>
                        <div class="md-layout">
                          <div class="head">เขต/อำเภอ <span style="color:red">*</span></div>
                          <div class="detail">
                            <md-field>
                              <md-input
                                v-model="newShipment.acc_district"
                                class="input-style2"
                              ></md-input>
                            </md-field>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col xl>
                        <div class="md-layout">
                          <div class="head">แขวง/ตำบล <span style="color:red">*</span></div>
                          <div class="detail">
                            <md-field>
                              <md-input
                                v-model="newShipment.acc_sub_district"
                                class="input-style2"
                              ></md-input>
                            </md-field>
                          </div>
                        </div>
                      </b-col>
                      <b-col xl>
                        <div class="md-layout">
                          <div class="head">รหัสไปรษณีย์ <span style="color:red">*</span></div>
                          <div class="detail">
                            <md-field>
                              <md-input
                                v-model="newShipment.acc_zip_code"
                                class="input-style2"
                              ></md-input>
                            </md-field>
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                  </b-container>
                </div>
                <div class="box-footer">
                  <span @click="dialogAddShipment = false" style="cursor: pointer;">ยกเลิก</span>
                  <v-btn rounded @click="addShipment" class="ok" :style="{ 'margin-left': '20px' }">
                    {{ isEditShipment ? 'บันทึกการแก้ไข' : 'บันทึก' }}
                  </v-btn>
                </div>
              </div>
            </div>
          </v-card>
        </v-dialog>
      </div>
      <div :style="{ width: windowSize <= 600 ? '0%' : '35%' }" class="right">
        <img
          style="width:444px; height: 444px;"
          class="img"
          src="@/assets/images/confrim2.png"
        />
      </div>
    </div>
    <div class="box-2"></div>
  </div>
</template>

<script>
import Vue from 'vue'
var CryptoJS = require('crypto-js')
export default {
  name: 'userprofilepage',
  data () {
    return {
      tab: 'profile',
      windowSize: '',
      isDisabled: true,
      dialog: false,
      dialog_success: false,
      dialogAddShipment: false,
      input_cheang_password: false,
      type_password: 'password',
      Error: {
        errorClassPwd: '',
        errorClassPwd_txt: '',
        errorClassNewPwd: '',
        errorClassNewPwd_txt: '',
        errorClassConfNewPwd: '',
        errorClassConfNewPwd_txt: '',
        errorClassFirstName: '',
        errorClassFirstName_txt: '',
        errorClassLastName: '',
        errorClassLasttName_txt: '',
        errorClassTel: '',
        errorClassTel_txt: '',
        errorClassEmail: '',
        errorClassEmail_txt: ''
      },
      profile: {},
      edit_val: {
        val_pass: '999999',
        new_password: '',
        confrim_password: ''
      },
      shipmentData: [], // array สำหรับข้อมูล shipment
      loading_status: false,
      checkbox: false,

      icon_eye: {
        password: false,
        new_password: false,
        confrim_new_password: false
      },

      newShipment: {
        acc_name: '',
        acc_phone: '',
        acc_address: '',
        acc_province: '',
        acc_district: '',
        acc_sub_district: '',
        acc_zip_code: ''
      },
      editShipmentIndex: null,
      isEditShipment: false,
    }
  },
  computed: {
    loading () {
      return this.$store.getters.isLoading
    }
  },
  watch: {},
  methods: {
    onClickShipmentTab() {
      this.tab = 'shipment'
      this.fetchShipmentList()
    },
    fetchShipmentList() {
      const data = { event: 'get', user_id: user_id };
      this.$store.dispatch('fetchShipmentList', data).then(res => {
        if (res.data && res.data.success && res.data.success.data) {
          this.shipmentData = res.data.success.data.map(item => ({
            acc_name: item.from_name || '',
            acc_phone: item.from_tel || '',
            acc_address: item.from_address || '',
            acc_sub_district: item.from_district || '',
            acc_district: item.from_state || '',
            acc_province: item.from_province || '',
            acc_zip_code: item.from_postcode ? String(item.from_postcode) : '',
            id: item.id || ""
          }))
        } else {
          this.shipmentData = []
        }
      })
    },
    renderStatus(row, mode) {
      if (mode == 'class') {
        return row.is_active == 1 ? 'active' : 'inactive'
      } else {
        return row.is_active == 1 ? 'Active' : 'Inactive'
      }
    },
    view(row) {
      // handle แก้ไข shipment
      // ตัวอย่าง: this.$emit('viewEdit', row)
    },
    view_add() {
      this.isEditShipment = false;
      this.newShipment = {
        acc_name: '',
        acc_phone: '',
        acc_address: '',
        acc_province: '',
        acc_district: '',
        acc_sub_district: '',
        acc_zip_code: ''
      };
      this.dialogAddShipment = true;
    },
    editShipment(shipment, index) {
      this.dialogAddShipment = true;
      // Map field จาก backend ให้ตรงกับฟอร์ม
      this.newShipment = {
        acc_name: shipment.from_name || '',
        acc_phone: shipment.from_tel || '',
        acc_address: shipment.from_address || '',
        acc_province: shipment.from_province || '',
        acc_district: shipment.from_state || '',
        acc_sub_district: shipment.from_district || '',
        acc_zip_code: shipment.from_postcode || '',
        acc_email: shipment.from_email || '',
        is_default: shipment.is_default === 1
      };
      this.isEditShipment = true;
      this.editShipmentIndex = index;

      // 1. อัปเดต districtList
      const selectedProvince = provinces.find(p => p.PROVINCE_NAME === this.newShipment.acc_province);
      this.districtList = selectedProvince
        ? districts.filter(d => d.PROVINCE_ID === selectedProvince.PROVINCE_ID)
        : [];

      // 2. อัปเดต subDistrictList
      const selectedDistrict = this.districtList.find(d => d.DISTRICT_NAME.replace(/^\*/, '') === this.newShipment.acc_district);
      this.subDistrictList = selectedDistrict
        ? subDistricts.filter(s => s.DISTRICT_ID === selectedDistrict.DISTRICT_ID)
        : [];

      // 3. อัปเดต zipCodeList
      const selectedSubDistrict = this.subDistrictList.find(s => s.SUB_DISTRICT_NAME.replace(/^\*/, '') === this.newShipment.acc_sub_district);
      this.zipCodeList = selectedSubDistrict
        ? zipcodes.filter(z => z.SUB_DISTRICT_ID == selectedSubDistrict.SUB_DISTRICT_ID)
        : [];
    },
    deleteShipment(shipment, index) {
      this.$store.dispatch('fetchShipmentList', {
        event: 'delete',
        id: shipment.id,
        user_id: this.data.user_id
      })
        .then(() => {
          this.fetchShipmentList();
        });
      // ล้างค่า newShipment และสถานะแก้ไข
      this.newShipment = {
        acc_name: '',
        acc_phone: '',
        acc_address: '',
        acc_province: '',
        acc_district: '',
        acc_sub_district: '',
        acc_zip_code: ''
      };
      this.isEditShipment = false;
      this.editShipmentIndex = null;
    },
    // deleteShipment(row, index) {
    //   // ลบ shipment
    //   const data = { event: 'delete', id: row.id, user_id: this.profile.user_id };
    //   this.$store.dispatch('fetchShipmentList', data).then(res => {
    //     if (res.data && res.data.success) {
    //       this.shipmentData.splice(index, 1); // ลบจาก array
    //     } else {
    //       // แจ้งเตือนหากลบไม่สำเร็จ
    //       console.error('Failed to delete shipment');
    //     }
    //   }).catch(error => {
    //     console.error('Error deleting shipment:', error);
    //   });
    // },
    addShipment() {
      // ตรวจสอบว่ากรอกครบหรือไม่
      if (
        !this.newShipment.acc_name ||
        !this.newShipment.acc_phone ||
        !this.newShipment.acc_address ||
        !this.newShipment.acc_province ||
        !this.newShipment.acc_district ||
        !this.newShipment.acc_sub_district ||
        !this.newShipment.acc_zip_code
      ) {
        // แจ้งเตือนหรือ highlight ช่องที่ไม่ครบได้
        return;
      }

      // เตรียมข้อมูลสำหรับ insert หรือ update
      const shipmentData = {
        event: this.isEditShipment ? 'update' : 'insert',
        user_id: this.profile.user_id,
        id: this.isEditShipment && this.editShipmentIndex !== null ? this.shipmentData[this.editShipmentIndex].id : undefined,
        from_name: this.newShipment.acc_name,
        from_tel: this.newShipment.acc_phone,
        from_address: this.newShipment.acc_address,
        from_province: this.newShipment.acc_province,
        from_state: this.newShipment.acc_district,
        from_district: this.newShipment.acc_sub_district,
        from_postcode: this.newShipment.acc_zip_code,
        from_country: 'Thailand'
      };

      this.$store
        .dispatch('fetchShipmentList', shipmentData)
        .then(res => {
          this.dialogAddShipment = false;
          this.dialog_success = true;
          // โหลด shipmentList ใหม่จาก backend
          this.fetchShipmentList();
          this.isEditShipment = false;
          this.editShipmentIndex = null;
          // Reset newShipment
          this.newShipment = {
            acc_name: '',
            acc_phone: '',
            acc_address: '',
            acc_province: '',
            acc_district: '',
            acc_sub_district: '',
            acc_zip_code: '',
            acc_email: '',
            is_default: false
          };
        })
        .catch(error => {
          // handle error
        });
    },
    onResize () {
      this.windowSize = window.innerWidth
    },
    edit () {
      this.type_password = 'text'
      this.isDisabled = false
    },
    save () {
      let inp1 = this.checkErrorCase('inp-email', this.profile.user_email)
      let inp2 = this.input_cheang_password ? true : this.checkErrorCase('inp-name', this.profile.user_name)
      let inp3 = this.input_cheang_password ? true : this.checkErrorCase('inp-surname', this.profile.user_surname)
      let inp4 = this.checkErrorCase('inp-phone', this.profile.user_phone)

      if (this.input_cheang_password) {
        console.log('C P ')
        let inp8 = false
        let inp5 = this.checkErrorCase('inp-password', this.edit_val.val_pass)
        let inp6 = this.checkErrorCase(
          'inp-new-password',
          this.edit_val.new_password
        )
        let inp7 = this.checkErrorCase(
          'inp-conf-new-password',
          this.edit_val.confrim_password
        )

        if (inp6 && inp7 && inp5) {
          inp8 = this.checkErrorCase('inp-check-conf-pass', '')
        }

        // console.log(inp1 ,inp2 ,inp3 ,inp4,inp5,inp6,inp7,inp8)
        if (inp1 && inp2 && inp3 && inp4 && inp5 && inp6 && inp7 && inp8) {
          var pwd = this.edit_val.val_pass
          let keyapp = 'DropShipSecretKey'
          var encrypted = CryptoJS.AES.encrypt(pwd, keyapp)

          var pwd2 = this.edit_val.new_password
          let keyapp2 = 'DropShipSecretKey'
          var encrypted2 = CryptoJS.AES.encrypt(pwd2, keyapp2)

          let res = {
            user_id: this.profile.user_id,
            old_password: encodeURI(encrypted),
            new_password: encodeURI(encrypted2)
          }
          this.$store
            .dispatch('changePassword', res)
            .then(res => {
              // console.log(res)
              this.Error.errorClassPwd = ''
              this.Error.errorClassPwd_txt = ''

              this.dialog_success = true
              this.cancel()
            })
            .catch(error => {
              if (error.response.status == 400) {
                this.Error.errorClassPwd = 'error-case'
                this.Error.errorClassPwd_txt = this.$t('txt-wrong9')
                console.log('Error 400')
              }
            })
        } else {
          // console.log('save & cheang Password  ==> NOT OK!!!')
        }
      } else {
        if (inp1 && inp2 && inp3 && inp4) {
          let res = {
            user_id: this.profile.user_id,
            user_email: this.profile.user_email,
            user_name: this.profile.user_name,
            user_surname: this.profile.user_surname,
            user_phone: this.profile.user_phone.replace(/ |_/g, '')
          }
          // console.log(res)
          this.$store
            .dispatch('updateProfile', res)
            .then(res => {
              let TheArray = JSON.parse(Vue.localStorage.get('user_profile'))
              TheArray.user_email = this.profile.user_email
              TheArray.user_name = this.profile.user_name
              TheArray.user_surname = this.profile.user_surname
              TheArray.user_phone = this.profile.user_phone
              Vue.localStorage.set('user_profile', JSON.stringify(TheArray))
              this.dialog_success = true

              this.cancel()
            })
            .catch(error => {
              if (error.response.status == 400) {
                this.Error.errorClassEmail = 'error-case'
                this.Error.errorClassEmail_txt = this.$t('txt-wrong14')
                console.log('Error 400')
              }
            })
          // console.log('save Profile ==> OK')
        } else {
          // console.log('save Profile ==> NOT OK!!!')
        }
      }

      // console.log('save')
    },
    checkErrorCase (type, value) {
      // console.log(type , '==> ',value)

      if (type == 'inp-email') {
        if (value == null || value == '') {
          ;(this.Error.errorClassEmail = 'error-case'),
            (this.Error.errorClassEmail_txt = this.$t('txt-wrong11'))
          return false
        } else if (!this.syntaxEmail(value)) {
          ;(this.Error.errorClassEmail = 'error-case'),
            (this.Error.errorClassEmail_txt = this.$t('txt-wrong5'))
          return false
        } else {
          this.Error.errorClassEmail = ''
          this.Error.errorClassEmail_txt = ''
          return true
        }
      }

      if (type == 'inp-name'  && !this.input_cheang_password) {
        if (value == null || value == '') {
          this.Error.errorClassFirstName = 'error-case'
          this.Error.errorClassFirstName_txt = this.$t('txt-wrong11')
          return false
        } else {
          this.Error.errorClassFirstName = ''
          this.Error.errorClassFirstName_txt = ''
          return true
        }
      }

      if (type == 'inp-surname' && !this.input_cheang_password) {
        if (value == null || value == '') {
          this.Error.errorClassLastName = 'error-case'
          this.Error.errorClassLastName_txt = this.$t('txt-wrong11')
          return false
        } else {
          this.Error.errorClassLastName = ''
          this.Error.errorClassLastName_txt = ''
          return true
        }
      }

      if (type == 'inp-phone') {
        // console.log(value
        if (value == null || value == '' || value == '-') {
          ;(this.Error.errorClassTel = 'error-case'),
            (this.Error.errorClassTel_txt = this.$t('txt-wrong11'))
          return false
        } else {
          ;(this.Error.errorClassTel = ''), (this.Error.errorClassTel_txt = '')
          return true
        }
      }

      if (type == 'inp-password') {
        if (value == null || value == '') {
          this.Error.errorClassPwd = 'error-case'
          this.Error.errorClassPwd_txt = this.$t('txt-wrong11')
          return false
        } else if (!this.syntaxPassword(value)) {
          this.Error.errorClassPwd = 'error-case'
          this.Error.errorClassPwd_txt = this.$t('txt-wrong10')
          return false
        } else {
          this.Error.errorClassPwd = ''
          this.Error.errorClassPwd_txt = ''
          return true
        }
      }

      if (type == 'inp-new-password') {
        if (value == null || value == '') {
          this.Error.errorClassNewPwd = 'error-case'
          this.Error.errorClassNewPwd_txt = this.$t('txt-wrong11')
          return false
        } else if (!this.syntaxPassword(value)) {
          this.Error.errorClassNewPwd = 'error-case'
          this.Error.errorClassNewPwd_txt = this.$t('txt-wrong10')
          return false
        } if( this.edit_val.val_pass ==  value){
          this.Error.errorClassNewPwd = 'error-case'
          this.Error.errorClassNewPwd_txt = this.$t('txt-wrong16')
          return false
        } else {
          this.Error.errorClassNewPwd = ''
          this.Error.errorClassNewPwd_txt = ''
          return true
        }
      }

      if (type == 'inp-conf-new-password') {
        if (value == null || value == '') {
          this.Error.errorClassConfNewPwd = 'error-case'
          this.Error.errorClassConfNewPwd_txt = this.$t('txt-wrong11')
          return false
        } else if (!this.syntaxPassword(value)) {
          this.Error.errorClassConfNewPwd = 'error-case'
          this.Error.errorClassConfNewPwd_txt = this.$t('txt-wrong10')
          return false
        } else {
          this.Error.errorClassConfNewPwd = ''
          this.Error.errorClassConfNewPwd_txt = ''
          return true
        }
      }

      if (type == 'inp-check-conf-pass') {
        if (this.edit_val.new_password != this.edit_val.confrim_password) {
          this.Error.errorClassConfNewPwd = 'error-case'
          this.Error.errorClassNewPwd = 'error-case'
          this.Error.errorClassConfNewPwd_txt = this.$t('txt-wrong8')
          return false
        } else {
          this.Error.errorClassNewPwd = ''
          this.Error.errorClassConfNewPwd = ''
          this.Error.errorClassConfNewPwd_txt = ''
          return true
        }
      }
    },
    cancel () {
      this.profile = JSON.parse(Vue.localStorage.get('user_profile'))

      this.Error.errorClassPwd = ''
      this.Error.errorClassPwd_txt = ''
      this.Error.errorClassNewPwd = ''
      this.Error.errorClassNewPwd_txt = ''
      this.Error.errorClassConfNewPwd = ''
      this.Error.errorClassConfNewPwd_txt = ''
      this.Error.errorClassFirstName = ''
      this.Error.errorClassFirstName_txt = ''
      this.Error.errorClassLastName = ''
      this.Error.errorClassLasttName_txt = ''
      this.Error.errorClassTel = ''
      this.Error.errorClassTel_txt = ''
      this.Error.errorClassEmail = ''
      this.Error.errorClassEmail_txt = ''

      this.edit_val.val_pass = '999999'
      this.isDisabled = true
      this.input_cheang_password = false
      this.type_password = 'password'
    },
    cheang () {
      if (this.type_password == 'password') {
        this.type_password = 'text'
      } else {
        this.type_password = 'password'
      }
    },
    HideShow (param) {
      if (param == 'password') {
        if (this.icon_eye.password) {
          this.icon_eye.password = false
        } else {
          this.icon_eye.password = true
        }
      }

      if (param === 'new_password') {
        if (this.icon_eye.new_password) {
          this.icon_eye.new_password = false
        } else {
          this.icon_eye.new_password = true
        }
      }
      if (param == 'confrim_new_password') {
        if (this.icon_eye.confrim_new_password) {
          this.icon_eye.confrim_new_password = false
        } else {
          this.icon_eye.confrim_new_password = true
        }
      }
    },
    cheang_password () {
      this.dialog = true
    },
    success_ () {
      this.dialog_success = false
    //  const master =  JSON.parse(sessionStorage.getItem('user_profile'))
    //   master.user_name  = 'xxxxxx'
    //   setTimeout(() => {
        
    //   const pro = sessionStorage.getItem('user_profile')
    //   console.log(master)
    //   sessionStorage.setItem('user_profile' , pro )
    //   }, 1000);
      location.reload()
    },
    confrim_dialog (param) {
      this.dialog = false
      if (param == 'OK') {
          this.Error.errorClassPwd = ''
          this.Error.errorClassPwd_txt = ''
          this.Error.errorClassNewPwd = ''
          this.Error.errorClassNewPwd_txt = ''
          this.Error.errorClassConfNewPwd = ''
          this.Error.errorClassConfNewPwd_txt = ''

          this.Error.errorClassFirstName = ''
          this.Error.errorClassFirstName_txt = ''
          this.Error.errorClassLastName = ''
          this.Error.errorClassLasttName_txt = ''
          this.Error.errorClassTel = ''
          this.Error.errorClassTel_txt = ''
          this.Error.errorClassEmail = ''
          this.Error.errorClassEmail_txt = ''

      

        this.edit_val.val_pass = ''
        this.edit_val.new_password = ''
        this.edit_val.confrim_password = ''

        this.input_cheang_password = true
        this.profile.use_password = ''
        this.profile.confrim_new_password = ''
        this.profile.new_password = ''

        this.profile = JSON.parse(Vue.localStorage.get('user_profile'))
      } else {
      }
    },
    syntaxEmail (email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true
      } else {
        return false
      }
    },
    syntaxPassword (password) {
      var regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{7,}$/
      if (regex.test(password)) {
        return true
      } else {
        return false
      }
    },
    syntaxPhoneNumber (phone) {
      var regex = /[0-9]/
      if (regex.test(phone)) {
        return true
      } else {
        return false
      }
    }
  },
  components: {},
  created () {
    if (
      this.$store.getters.user_profile === null &&
      sessionStorage.getItem('user_profile') === null
    ) {
      this.$store.dispatch('LogOut').then(() => {
        this.$router.push('/')
      })
    } else if (sessionStorage.getItem('user_profile') !== null) {
      let data = JSON.parse(sessionStorage.getItem('user_profile'))
      if (data.user_role != 'admin') {
        this.$rouvdialogter.push('/' + 'adminHome')
      } else {
        this.profile = JSON.parse(Vue.localStorage.get('user_profile'))
      }
    }
    //  if (Vue.localStorage.get("login") == null) {
    //   this.$router.replace("/");
    // } else {
    //   this.profile = JSON.parse(Vue.localStorage.get('user_profile'))

    // }
  },
  mounted () {}
}
</script>
<style>
.v-dialog:not(.v-dialog--fullscreen) {
  border-radius: 40px;
}
.error-case {
  border: 1px solid red;
  font-size: 12px;
  font-family: 'Bai Jamjuree', sans-serif;
}
</style>
